import React, { FC } from 'react';
import { translate } from '@fiverr-private/i18n-react';
import { Link, LinkProps } from '@fiverr-private/typography';
import { sendBigQueryEvent } from '../helpers/events/sendBigQueryEvent';
import { BQ_CLICKED_SEE_MORE_GUIDES } from '../helpers/events/bigQueryEventTypes';
import { sendMixpanelEvent } from '../helpers/mixpanelEvents';
import { MIXPANEL_EVENT_TITLE } from '../helpers/constants';

interface SeeMoreLinkProps extends LinkProps {
  text?: string | number;
  link?: string;
  sourcePageKey: string;
}

export const SeeMoreLink: FC<SeeMoreLinkProps> = ({ text = '', link = '', sourcePageKey, ...props }) => {
  const fiverrGuidesHomepageUrl = link || '/resources/guides';

  const handleClickLink = () => {
    sendBigQueryEvent({
      eventName: BQ_CLICKED_SEE_MORE_GUIDES,
      params: {
        sourcePageKey,
      },
    });
    sendMixpanelEvent({
      eventName: MIXPANEL_EVENT_TITLE.CLICKED_SEE_MORE_GUIDES,
      categoryName: sourcePageKey,
      linkUrl: fiverrGuidesHomepageUrl,
    });
  };

  return (
    <Link
      href={fiverrGuidesHomepageUrl}
      target="_blank"
      onClick={handleClickLink}
      rel="noreferrer"
      color={{
        default: 'grey_1200',
        hover: 'grey_1200',
      }}
      textAlign="end"
      marginTop={{
        default: '3',
        md: '0',
      }}
      decoration={{
        default: 'none',
        hover: 'underline',
      }}
      {...props}
    >
      {text || translate('seo_content.related_guides.see_more_guides')}
    </Link>
  );
};
